import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import CommissionshareRepository from '@/shared/http/repositories/realestate/commissionshare'

export default {
  name: 'CommissionSales',
  props: ['selectedComissao'],
  components: { HeadDetailsGama },
  data () {
    return {
      consultaparcela: [],
      headTable: ['Valor da Parcela', 'Vencimento', 'Status']
    }
  },
  mixins: [ActionsForm],
  methods: {
    onLoad () {
      CommissionshareRepository.GetParcelas(this.selectedComissao.id)
        .then(Response => {
          this.consultaparcela = Response.data.data
          this.$refs.tableGridParcela.LoadAllByData(Response)
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesinquiry/components/commissionsales/commissionsales.js